import { useState, useEffect, useCallback } from "react";
import { getUsersList, searchUsers } from "../services/userServices";

function useUsersData(searchTerm, page = 1) {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [totalUsers, setTotalUsers] = useState(0);
  const [perPage, setPerPage] = useState(10);

  const loadUsers = useCallback(async () => {
    setLoading(true);
    try {
      const response = searchTerm
        ? await searchUsers(searchTerm, page)
        : await getUsersList(page);


        if (response?.data?.users) {
          const { users } = response.data;
          const { total_count, per_page } = response.meta || {};
          setUsers(users);
          setTotalUsers(total_count || users.length);
          setPerPage(per_page || 10);
        }
        
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [searchTerm, page]);

  useEffect(() => {
    loadUsers();
  }, [loadUsers]);

  return { users, loading, error, totalUsers, perPage, refetch: loadUsers };
}

export default useUsersData;
